import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { getComments } from 'modules/comment/comment.actions';
import { Box, Row, BodyText, Divider, InlineLink } from 'modules/styled';

ShowHidden.propTypes = {
  id: PropTypes.string,
};

export function ShowHidden({ id }) {
  const [showAll, setShowAll] = useState();
  const dispatch = useDispatch();
  if (showAll) return null;
  return (
    <Box>
      <Divider sx={{ flex: 1, height: 1 }} />
      <Row
        sx={{
          mt: 6,
          mb: 12,
          mx: [2, 4],
          flexWrap: 'wrap',
          alignItems: 'baseline',
        }}
      >
        <BodyText>Some low-ranking comments may have been hidden. </BodyText>
        <InlineLink
          inline={1}
          onClick={(e) => {
            e && e.preventDefault();
            dispatch(getComments(id, { showHidden: true }));
            setShowAll({ showAll: true });
          }}
        >
          <BodyText sx={{ color: 'blue' }}>Show hidden comments</BodyText>
        </InlineLink>
      </Row>
    </Box>
  );
}
